// extracted by mini-css-extract-plugin
module.exports = {"warapper":"WrapperContent_warapper__uefDc","wrapperHeader":"WrapperContent_wrapperHeader__3Lgjv","wrapperBody":"WrapperContent_wrapperBody__26b1R"};